import React, { useState } from 'react';
import VideoPlayer from 'react-video-player-extended';
import IntroVideo from '../assets/videos/intro-video.mp4'

export const HomeVideoPlayer = () => {
  const [isPlaying , setIsPlaying] = useState(false);
  const [volume , setVolume] = useState(1.0);

  const handlePlay = () => {
    setIsPlaying(true);
  };

  const handlePause = () => {
    setIsPlaying(false);
  };

  const handleVolume = value => {
    setVolume(value);
  };

  return (
    <VideoPlayer
      url={IntroVideo}
      isPlaying={isPlaying}
      volume={volume}
      onPlay={handlePlay}
      onPause={handlePause}
      onVolume={handleVolume}
      width={'800px'}
      height={'auto'}
    />
  )
}
